import React from "react";

const Viewallrefunds = () => {
    return (
        <div>
            <h1 className="mt-8 text-xl font-bold">View all Booking Refunds</h1>
        </div>
    )
}

export default Viewallrefunds